import {makeLogger} from '../../../../logger/logger';

const { err } = makeLogger({
  pathToCurrentFile: 'components/result-page/result-cards/utils/DateFormatter.tsx',
  loggersList: ['err']
});
const regexStringPattern = '^(\\d{1,4})<sign>(\\d{1,4})<sign>(\\d{1,4})';
const unixPatternInSeconds = /^(\d{10})$/;
const unixPatternInMiliseconds = /^(\d{13})$/;

function dateArrayValidator(
  dateArray: string[]
): false | { yyyy: number; mm: number; dd: number } {
    const daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    const isStartsFromYear =
    dateArray[0].length === 4 &&
    dateArray[2].length !== 4 &&
    dateArray.some((value) => value.length > 2);
    const [yyyy, mm, dd] = (
      isStartsFromYear ? dateArray : dateArray.reverse()
    ).map((value) => parseInt(value));

    let lyear = false;

    if (mm === 1 || mm > 2) {
      if (dd > daysInMonth[mm - 1]) {
        return false;
      }
    }

    if (mm === 2) {
      if ((!(yyyy % 4) && yyyy % 100) || !(yyyy % 400)) {
        lyear = true;
      }
    }

    if (((!lyear && dd >= 29) || (lyear && dd > 29)) && mm === 2) {
      return false;
    }

    return { yyyy, mm, dd };
}

function checkAndSplit(dateString, sign): [string?, string?, string?] {
    const pattern = regexStringPattern.replace(/<sign>/g, `\\${sign}`);
    const regex = new RegExp(pattern);

    if (dateString.match(regex)) {
      return dateString.split(sign);
    }

    return [];
}

function parseDateString(dateString: string): Date | string {
    const separators = ['.', '/', '-'];
    let dateValidValue: false | { yyyy: number; mm: number; dd: number };

    if (dateString.match(unixPatternInSeconds)) {
      const arrayDate: RegExpMatchArray =
      dateString.match(unixPatternInSeconds);
      return new Date(parseInt(arrayDate[0]) * 1000);
    }

    if (dateString.match(unixPatternInMiliseconds)) {
      const arrayDate: RegExpMatchArray = dateString.match(
        unixPatternInMiliseconds
      );
      return new Date(parseInt(arrayDate[0]));
    }

    separators.forEach((sign) => {
        const possibleDateArray = checkAndSplit(dateString, sign);

        if (possibleDateArray.length === 3) {
          dateValidValue = dateArrayValidator(possibleDateArray);
        }
    });

    if (dateValidValue) {
      return new Date(
        dateValidValue.yyyy,
        dateValidValue.mm - 1,
        dateValidValue.dd
      );
    }
    err.log('Error while parsing date', dateString);
    return '';
}

export function formatDateShort(locale, dateString) {
    try {
      const [day, month, year] = dateString.substr(0, 10).split('/');
      const options: any = { year: 'numeric', month: '2-digit', day: '2-digit' };//eslint-disable-line @typescript-eslint/no-explicit-any
      return Intl.DateTimeFormat(locale ?? 'default', options).format(
        new Date(year, month - 1, day)
      );
    } catch (ignored) {
      err.log('Error while parsing date', dateString);
      return '';
    }
}

export function formatDate(dateString: string, locale: string = null) {
    try {
      const options: any = { year: 'numeric', month: 'long', day: 'numeric' }; //eslint-disable-line @typescript-eslint/no-explicit-any
      const parsedDate = parseDateString(dateString);

      return (
        typeof parsedDate === 'object'
          ? new Intl.DateTimeFormat(
            locale ?? 'default',
            options
          ).format(parsedDate)
          : dateString
      );
    } catch (ignored) {
      err.log('Error while parsing date', dateString);
      return '';
    }
}
